import { Line } from 'react-chartjs-2'

export default function ChartDaySelect({ data, title, monthColorMap }: any) {
    const labels = data[0]?.days?.map((item: any) => item.day) ?? Array.from({ length: 31 }, (_, i) => i + 1)

    const datasets = data.map((item: any) => ({
        label: item.month,
        data: item.days?.map((day: any) => day.sum),
        borderWidth: 2,
        borderColor: monthColorMap[item.month],
        backgroundColor: monthColorMap[item.month],
        datalabels: {
            color: monthColorMap[item.month],
        },
    }))

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                anchor: 'end',
                align: 'top',
                offset: 4,
                padding: {
                    top: 4
                },
                backgroundColor: function (context: any) {
                    return context.dataset.hidden || context.raw === 0 ? null : 'rgba(255, 255, 255, 0.7)';
                },
                borderRadius: 4,
                font: {
                    weight: 'bold',
                    size: 14
                },
                formatter: (value: any) => value === 0 ? '' : value,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Line data={{ labels, datasets }} options={options} />
    )
}
